import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import Hero from './Hero';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import StorySection from './StorySection';
import FeaturesSection from './FeaturesSection';
import LeadCaptureSection from './LeadCaptureSection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <StorySection />
        <FeaturesSection />
        <LeadCaptureSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;